module.exports = __webpack_public_path__ + "static/media/34-4.3016a56f.mp3";